module.exports = __webpack_public_path__ + "img/微信图片_20211103170146.76b56600.jpg";